import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import Configuration from "../../../containers/modules/accounting/configuration";

export default function ConfigurationRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="configuration"
      index
      element={
        <AccessControl
          name={"Acc Config List"}
          auth={authUser}
          component={() => <Configuration />}
        />
      }
    />
  );
}
